import { render } from "./Connections.vue?vue&type=template&id=168efa37"
import script from "./Connections.vue?vue&type=script&lang=js"
export * from "./Connections.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.15.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__